import { TableProps } from '@shared/Table'
import { t } from 'i18next'

import {
  TableCommentDataType,
  TableHistoryDataType,
} from 'store/types/salaryCard'

export const columns: () => TableProps<
  Omit<TableHistoryDataType, 'key'>
>['editColumns'] = () => ({
  actionDate: {
    title: t('orders.salaryCardOrder.tableTitles.date'),
    width: 40,
  },
  operatorUsername: {
    title: t('orders.salaryCardOrder.tableTitles.userName'),
    width: '15%',
  },
  previousStatus: {
    title: t('transfers.actionWithTransaction'),
    width: 100,
    render(value, record, index) {
      return value
        ? t(`orders.salaryCardOrder.buttonsLabels.RadioButtonGroup.${value}`)
        : ''
    },
  },
  actionWithOrderStatus: {
    title: t('orders.salaryCardOrder.tableTitles.workingWithTransfer'),
    render(value, record, index) {
      return t(`orders.salaryCardOrder.statusList.transferStatus.${value}`)
    },
  },
  acquiredStatus: {
    title: t('transfers.acquiredStatus'),
    render(value, record, index) {
      return t(`orders.salaryCardOrder.buttonsLabels.RadioButtonGroup.${value}`)
    },
  },
})

export const commentColumns: () => TableProps<TableCommentDataType>['editColumns'] =
  () => ({
    date: {
      title: t('orders.salaryCardOrder.tableTitles.date'),
      ellipsis: true,
      width: '50%',
    },
    comment: {
      title: t('orders.salaryCardOrder.tableTitles.comment'),
    },
  })
